// extracted by mini-css-extract-plugin
export default {"content":"ContentWrapper_content__GyEYf"};